import { rasterSrc } from "@/generated/raster-images";
import { createFileRoute } from "@tanstack/react-router";
import { PageHero, Section, SectionHeader, AwardsRow, CTABand } from "@/components/site-blocks";
import { ACCREDITATIONS } from "@/lib/site";
import { ShieldCheck } from "lucide-react";
import { pageSeo } from "@/lib/seo";

export const Route = createFileRoute("/accreditations")({
  head: () => ({
    ...pageSeo({
      path: "/accreditations",
      title: "Accreditations: Stroma, TrustMark, HIES, Gas Safe | CRS Energy",
      description:
        "CRS Energy holds Stroma, TrustMark, HIES, OSCAR, Gas Safe, REFCOM, Constructionline and CHAS accreditations. Fully insured remediation and energy-efficiency contractor.",
    }),
  }),
  component: AccreditationsPage,
});

function AccreditationsPage() {
  return (
    <>
      <PageHero
        eyebrow="Accreditations"
        title="Fully accredited, fully insured"
        description="Every certification that matters for remediation, insulation, heating and renewables work: independently verified."
        image={rasterSrc("stock/photo-1573164574511-73c773193279")}
        imageAlt="Construction site safety"
      />
      <Section>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {ACCREDITATIONS.map((a) => (
            <div key={a.slug} className="rounded-2xl border bg-card p-6">
              <div className="rounded-xl bg-primary-soft text-primary p-3 w-fit">
                <ShieldCheck className="h-6 w-6" aria-hidden />
              </div>
              <h3 className="mt-4 text-xl font-semibold">{a.name}</h3>
              <p className="mt-2 text-muted-foreground">{a.body}</p>
            </div>
          ))}
        </div>
      </Section>
      <Section className="bg-card">
        <SectionHeader eyebrow="Awards" title="Recognised work" />
        <AwardsRow />
      </Section>
      <CTABand />
    </>
  );
}
